import React from 'react';
import styled from 'styled-components';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import {Form, Input, Message} from 'semantic-ui-react';
import {Link, useHistory} from 'react-router-dom';
import {useQueryParam, StringParam} from 'use-query-params';
import {
  PositiveButton,
  BasicButton,
} from '../../../components/mypage/MypageLayout';
import {useSigninMutation} from 'api';
import CURRENT_USER from 'api/queries/currentUser';

const validateSchema = Yup.object().shape({
  email: Yup.string().trim().required('必須項目です'),
  password: Yup.string().trim().required('必須項目です'),
});

const Login = () => {
  const history = useHistory();
  const [returnUrl] = useQueryParam('return_url', StringParam);

  const [signin, {data, loading}] = useSigninMutation({
    update: (cache, {data}) => {
      if (!data.signin.error) {
        cache.writeQuery({
          query: CURRENT_USER,
          data: {currentUser: data.signin.user},
        });

        window.location.href = returnUrl || '/';
      }
    },
  });

  const formik = useFormik({
    validationSchema: validateSchema,
    initialValues: {
      email: '',
      password: '',
    },
    onSubmit: (values) => {
      signin({variables: values});
    },
  });

  return (
    <Container>
      <Title>ログイン</Title>

      {data?.signin?.error && (
        <Message negative>
          <p>{data.signin.error}</p>
        </Message>
      )}

      <Form onSubmit={formik.handleSubmit}>
        <Form.Field required className="field">
          <label>メールアドレス</label>
          <Input
            name="email"
            type="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.email && formik.errors.email && (
            <Message negative>{formik.errors.email}</Message>
          )}
        </Form.Field>
        <Form.Field required className="field">
          <label>パスワード</label>
          <Input
            name="password"
            type="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.password && formik.errors.password && (
            <Message negative>{formik.errors.password}</Message>
          )}
        </Form.Field>
        <div className="links">
          <Link to="reset_password">パスワードをお忘れの方はこちら</Link>
        </div>

        <Actions>
          <PositiveButton
            positive
            type="submit"
            size="large"
            loading={loading}
            disabled={loading || !formik.isValid}>
            メールアドレスでログイン
          </PositiveButton>
        </Actions>

        <div className="border"></div>

        <div className="signup">
          <p>アカウントをお持ちでない方はこちら</p>
          <BasicButton onClick={() => history.push('/signup')}>
            新規作成
          </BasicButton>
        </div>
      </Form>
    </Container>
  );
};

export {Login};

const Container = styled.div`
  padding-top: 90px;
  text-align: center;
  width: 400px;
  margin: 0 auto;
  margin-bottom: 90px;

  .description {
    margin-top: 20px;
    font-size: 12px;
    line-height: 1.5;
    color: #2c2c2c;

    p {
      margin-bottom: 0;
    }
  }

  .border {
    font-size: 13px;
    margin: 40px 0;
    height: 1px;
    border-top: solid 1px #999999;
    position: relative;

    p {
      position: absolute;
      top: -10px;
      left: 39%;
      background-color: #fff;
      width: 80px;
      text-align: center;
    }
  }

  label {
    text-align: left;
    opacity: 0.37;
    color: #333333;
    font-size: 12px;
  }

  input[type='email'],
  input[type='password'] {
    display: block;
    margin: 0 auto;
    width: 100%;
    height: 45px;
    background-color: #f5f5f5;
    border: solid 1px #f1f1f1;
  }

  .links {
    margin: 15px 0;
    text-align: left;
    font-size: 12px;
    line-height: 1.17;

    a {
      color: #ef5350;
    }
  }

  .signup {
    button {
      width: 153px;
      height: 3.5rem;
      border-radius: 30px !important;
    }
  }
`;

const Title = styled.h1`
  margin-bottom: 70px;
  font-size: 26px;
  font-weight: 500;
  text-align: center;
  color: #666666;
`;

const Facebook = styled.a`
  &&& {
    display: block;
    margin: 0 auto;
    width: 100%;
    height: 56px;
    line-height: 56px;
    background-color: #305097;
    color: #fff;
    font-size: 17px;
    letter-spacing: 0.5px;
    text-align: center;
    text-decoration: none;
    border-radius: 72.5px;

    &:hover {
      color: #fff;
      background-color: #4d6fbb;
      text-decoration: none;
      cursor: pointer;
    }

    i {
      margin-right: 10px;
    }
  }
`;

const Actions = styled.div`
  margin: 60px 0;
`;
